import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import React from "react/lib/React"; /** Do not remove this import, it's used by the toast library. */
import simpleFetch from "../../../../utils/simpleFetch";
import { GET_MENROL_EXIST } from "../../../utils/data/models";

export const getTenantFromURL = () => {
    return window.location.hostname.split(".")[0];
};

export const getMenrolInfoForTenant = (callback) => {
    try {
        simpleFetch("GET", GET_MENROL_EXIST.path, {}).then((response) => {
            const result = _.isEmpty(response) ? {} : response;
            callback(result);
        });
    } catch (e) {
        /** If a promise error for unauthorized is thrown (403) by simpleFetch we toast error. If not, we throw the error. */
        if (e.status === 403) {
            toast(<FormattedMessage id="error.403.title" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        } else {
            toast(<FormattedMessage id="error.unknown" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        }
        throw e;
    }
};



// WEBPACK FOOTER //
// ./src/components/common/MultiTenancy/MultiTenancyHelper.js